import React, { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FiCheckCircle } from 'react-icons/fi';
import TopBar from '../components/TopBar';
import { db } from '../firebase';
import layoutStyles from '../styles/layout.module.css';
import styles from './UnitPurchaseSuccess.module.css';
import {
  useCompactCollectibleImageUrl,
} from '../utils/collectibleMedia';

export default function UnitPurchaseSuccess() {
  const { unitId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [unit, setUnit] = useState(null);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setLoading(true);
        const unitSnap = await getDoc(doc(db, 'units', String(unitId)));
        if (!unitSnap.exists()) {
          if (active) {
            setUnit(null);
            setProduct(null);
          }
          return;
        }
        const unitData = { id: unitSnap.id, ...(unitSnap.data() || {}) };
        const productSnap = await getDoc(doc(db, 'products', String(unitData.productId || '')));
        const productData = productSnap.exists() ? { id: productSnap.id, ...(productSnap.data() || {}) } : null;
        if (!active) return;
        setUnit(unitData);
        setProduct(productData);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [unitId]);

  const Icon = FiCheckCircle;
  const productPath = String(location.state?.productId || product?.id || '').trim();
  const successBackTarget = productPath ? `/products/${productPath}` : '/fan';
  const mediaUrl = useCompactCollectibleImageUrl(product || {});

  return (
    <div className={layoutStyles.detailPage}>
      <TopBar
        variant="back"
        backLabel="Back"
        onBack={() => navigate(successBackTarget, { replace: true })}
        rightActionLabel="Home"
        onRightAction={() => navigate('/home')}
      />
      <div className={`${layoutStyles.detailMain} ${styles.page}`.trim()}>
        {loading ? <p className={styles.state}>Loading purchase…</p> : null}
        {!loading && unit && product ? (
          <section className={styles.hero}>
            <div className={styles.badge}><Icon /></div>
            <span className={styles.eyebrow}>Purchase Complete</span>
            <h1>Congratulations. This unit is now yours.</h1>
            <p className={styles.copy}>Your collectible has been secured and added to your library. Open the unit to manage resale timing, metadata, and ownership details.</p>
            <div className={styles.card}>
              <div className={styles.mediaWrap}>
                {mediaUrl ? <img src={mediaUrl} alt={product.title || 'Collectible'} /> : <div className={styles.placeholder}>Owned</div>}
              </div>
              <div className={styles.cardCopy}>
                <span className={styles.cardEyebrow}>Now Collected</span>
                <h2>{product.title || product.id}</h2>
                <p>Unit #{unit.unitNumber || '—'}{product.variantLabel ? ` · ${String(product.variantLabel)}` : ''}</p>
              </div>
            </div>
            <div className={styles.actions}>
              <button
                type="button"
                className={styles.primaryButton}
                onClick={() => navigate(`/units/${unit.id}`, { replace: true, state: { backTo: successBackTarget } })}
              >
                Open My Collectible
              </button>
            </div>
          </section>
        ) : null}
      </div>
    </div>
  );
}
